"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ApiClient_1 = __importDefault(require("../utils/ApiClient"));
var moment_1 = __importDefault(require("moment"));
var OrderRepository = /** @class */ (function () {
    function OrderRepository() {
    }
    OrderRepository.getFirstAvailableFulfilmentTime = function (payload) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                url = '/storefront/order/first-available-fulfilment-time';
                return [2 /*return*/, ApiClient_1.default.post(url, payload)];
            });
        });
    };
    OrderRepository.calculateTime = function (order) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                url = '/order/calculate';
                return [2 /*return*/, ApiClient_1.default.post(url, order)];
            });
        });
    };
    OrderRepository.calculateOrderDelivery = function (details) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                url = '/order/calculate_delivery';
                return [2 /*return*/, ApiClient_1.default.post(url, details)];
            });
        });
    };
    OrderRepository.confirmTime = function (order) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                url = '/order/calculate?confirm=1';
                return [2 /*return*/, ApiClient_1.default.post(url, order)];
            });
        });
    };
    OrderRepository.create = function (order) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                url = '/order';
                return [2 /*return*/, ApiClient_1.default.post(url, __assign(__assign({}, order), { process_timestamp: (0, moment_1.default)(order.process_timestamp).toISOString(true) }))];
            });
        });
    };
    OrderRepository.createMenuOrder = function (menuOrder) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, ApiClient_1.default.post('/storefront/order', __assign(__assign({}, menuOrder), { fulfilment_datetime: (0, moment_1.default)(menuOrder.fulfilment_datetime).format('YYYY-MM-DD HH:mm:ss') }))];
            });
        });
    };
    OrderRepository.getDetails = function (orderId) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                url = "/orders/".concat(orderId);
                return [2 /*return*/, ApiClient_1.default.get(url)];
            });
        });
    };
    OrderRepository.delete = function (orderId) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                url = "/orders/".concat(orderId);
                return [2 /*return*/, ApiClient_1.default.delete(url)];
            });
        });
    };
    OrderRepository.getStatus = function (orderId) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                url = "/orders/".concat(orderId, "/payment_status");
                return [2 /*return*/, ApiClient_1.default.get(url)];
            });
        });
    };
    OrderRepository.getPendingOrders = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                url = '/orders/pending';
                return [2 /*return*/, ApiClient_1.default.get(url)];
            });
        });
    };
    OrderRepository.getPastOrders = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                url = '/orders/past';
                return [2 /*return*/, ApiClient_1.default.get(url)];
            });
        });
    };
    OrderRepository.getStorefrontOrders = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, ApiClient_1.default.get('/storefront/order/history')];
            });
        });
    };
    OrderRepository.checkCoupon = function (code, total) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                url = '/coupon';
                return [2 /*return*/, ApiClient_1.default.post(url, { coupon_code: code, total: total })];
            });
        });
    };
    OrderRepository.getReceivedStatus = function () {
        return ('NEW' || 'PLANNED' || 'PREPARING');
    };
    OrderRepository.getReadyStatus = function () {
        return 'READY';
    };
    OrderRepository.getPickedUpStatus = function () {
        return 'HANDLED';
    };
    return OrderRepository;
}());
exports.default = OrderRepository;
